import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Keeps Product Bento Grid content synchronized with the selected variant.
 * Production's VariantPicker already fetches the updated product HTML, so this
 * component consumes that response instead of making another request.
 */
class ProductCalloutBentoComponent extends Component {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    super.connectedCallback();

    this.#controller?.abort();
    this.#controller = new AbortController();

    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#controller = undefined;
  }

  /** @param {VariantUpdateEvent} event */
  #handleVariantUpdate = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const sourcePicker = event.target.closest('variant-picker');
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (!(sourcePicker instanceof HTMLElement) || sourcePicker.dataset.productId !== this.dataset.productId) {
      return;
    }

    const { html, productId } = event.detail.data;
    if (!html) return;
    if (!event.detail.data.newProduct && productId && productId !== this.dataset.productId) return;

    const replacement = Array.from(html.querySelectorAll('product-callout-bento-component[data-block-id]')).find(
      (candidate) => candidate instanceof HTMLElement && candidate.dataset.blockId === this.dataset.blockId
    );

    if (replacement) this.replaceWith(replacement);
  };
}

if (!customElements.get('product-callout-bento-component')) {
  customElements.define('product-callout-bento-component', ProductCalloutBentoComponent);
}
